import React from "react";
import styled from "styled-components";
import { Outlet } from "react-router";

//
import Navbar from "../components/navbar/Navbar";
import Footer from "../components/footer/Footer";
import FixedNavbar from "../components/navbar/FixedNavbar";
import ToTopBtn from "../components/to-top-btn/ToTopBtn";

export default function MainLayout() {
  return (
    <StyledMainLayout>
      <Navbar />
      <FixedNavbar />
      <div className="layout__outlet">
        <Outlet />
      </div>
      <Footer />
      <ToTopBtn />
    </StyledMainLayout>
  );
}

const StyledMainLayout = styled.div`
  .layout {
    &__outlet {
    }
  }
`;
